import React from 'react';

import { Box, Button } from '@mui/material';
import { isFunction, isNotNil } from 'es-toolkit';

import { InboxFilterButton } from 'src/components/inboxFilter';
import { TableSearch } from 'src/components/table';
import { useScreenInfo } from 'src/hooks/common';
import { useTestVerificationRequestsRoute } from 'src/hooks/testVerificationRequests';

import type { LayoutHeaderAction, LayoutHeaderProps } from './types';

export const LayoutHeader: React.FC<LayoutHeaderProps> = ({ searchProps, actionProps = {} }) => {
  const { onSearch, searchContainerStyles, searchFieldStyles, disabled } = searchProps;
  const { action, hidden: isActionHidden } = actionProps;

  const { isMobile } = useScreenInfo();
  const { isTestRequestsRoute } = useTestVerificationRequestsRoute();

  return (
    <Box paddingTop={2} paddingBottom={2} width="100%">
      <Box
        display="flex"
        flexDirection="row"
        alignItems="center"
        justifyContent="space-between"
        gap={2}
      >
        <Box display="flex" flexDirection="row" alignItems="center" gap={2}>
          <Box sx={searchContainerStyles}>
            <TableSearch
              onSearch={onSearch}
              searchFieldStyles={searchFieldStyles}
              disabled={disabled}
            />
          </Box>
          <React.Activity mode={isTestRequestsRoute ? 'hidden' : 'visible'}>
            <InboxFilterButton />
          </React.Activity>
        </Box>

        {!isMobile && (
          <Box>{!isActionHidden && isNotNil(action) && renderTopAction(action, isMobile)}</Box>
        )}
      </Box>

      {isMobile && (
        <Box sx={{ mt: 3, display: 'flex', justifyContent: 'flex-end' }}>
          {!isActionHidden && isNotNil(action) && renderTopAction(action, isMobile)}
        </Box>
      )}
    </Box>
  );
};

const renderTopAction = (action: LayoutHeaderAction, isMobile: boolean): React.ReactNode => {
  if (isFunction(action.render)) {
    return action.render();
  }

  return (
    <Button
      variant="contained"
      size={isMobile ? 'large' : 'medium'}
      color="primary"
      startIcon={action.icon}
      key={action.actionName}
      onClick={action.onAction}
      disabled={action.disabled}
      loading={action.loading}
    >
      {action.actionName}
    </Button>
  );
};
